import React, { useEffect, useState } from 'react'
import dayjs from '@utils/dayjs'
import toCalendarDate from '@utils/toCalendarDate'
import Calendar from 'react-calendar'
import { useFormContext } from 'react-hook-form'

interface Props {
  prefix: string
  required: boolean
}

const Menstruation: React.FC<Props> = ({ prefix, required }) => {
  const today = dayjs().tz()
  const { register, watch, setValue } = useFormContext()
  const startsAtName = `${prefix}.menstruation_value.starts_at`
  const startsAt = watch(startsAtName)
  const [date, setDate] = useState(() => toCalendarDate(startsAt || today))
  useEffect(() => {
    setValue(`${prefix}.menstruation_value.starts_at`, dayjs(date).format('YYYY-MM-DD'))
  }, [date])

  const maxJsDate = toCalendarDate(today)

  const handleChangeDate = (newDate) => {
    setDate(newDate)
  }

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-auto">
          <Calendar
            value={date}
            maxDate={maxJsDate}
            onChange={handleChangeDate}
            className="zm-calendar"
            formatDay={(_locale, d) => dayjs(d).format('D')}
          />
          <input
            ref={register({
              required: required && '日付を入力してください',
            })}
            type="hidden"
            name={startsAtName}
          />
        </div>
      </div>
      <div className="row justify-content-center py-4">
        <div className="col-auto form-inline">
          {dayjs(date).format('YYYY年M月D日')}
          から
          <div className="input-group pl-3">
            <input
              ref={register({
                valueAsNumber: true,
                required: required && '日数を入力してください',
                min: {
                  value: 0,
                  message: '日数は0以上で入力してください',
                },
                max: {
                  value: 99,
                  message: '日数は99以下で入力してください',
                },
              })}
              type="number"
              inputMode="numeric"
              name={`${prefix}.menstruation_value.days`}
              className="form-control border border-light bg-light zm-menstruation-days"
              aria-describedby={`${prefix}_menstruation_value`}
            />
            <div className="input-group-append">
              <span
                id={`${prefix}_menstruation_value`}
                className="input-group-text border-light bg-light"
              >
                日間
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Menstruation
